<template>
	<div v-if="disabled" class="action-floating-button">
		<slot/>
	</div>

	<a v-else class="action-floating-button" :href="href">
		<slot/>
	</a>
</template>

<script>
	import VueTypes from "vue-types"

	const defHref = "#";

	export default {
		props: {
			href: VueTypes.string.def(defHref),
			disabled: VueTypes.bool.def(false),
		},
		computed: {
			urlOff(){
				return this.href === defHref
				|| location.href.includes(this.href);
			}
		},
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/ActionFloatingButton" as *;
</style>